import { useEffect, useState } from 'react';

// نص عربي للوقت المتبقي/المتأخر لمباراة — لا يُستخدم لتغيير الحالة، عرض فقط
export const formatMatchCountdown = (matchDateStr, status) => {
  if (!matchDateStr) return null;
  const now = new Date();
  const match = new Date(matchDateStr);
  if (isNaN(match.getTime())) return null;
  const diffMs = match.getTime() - now.getTime();

  if (diffMs <= 0) {
    if (status !== 'awaiting_result') return null;
    const lateDays = Math.max(1, Math.floor(-diffMs / 86400000));
    const label = lateDays === 1 ? 'يوم واحد' : lateDays === 2 ? 'يومين' : `${lateDays} يوم`;
    return `بانتظار النتيجة — متأخرة ${label}`;
  }
  if (status === 'live') return null;

  const isSameDay = now.toDateString() === match.toDateString();
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const isTomorrow = tomorrow.toDateString() === match.toDateString();

  const totalMinutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (isSameDay && hours < 6) {
    const hourLabel = hours === 0 ? '' : hours === 1 ? 'ساعة و' : hours === 2 ? 'ساعتان و' : `${hours} ساعة و`;
    return `متبقي ${hourLabel}${minutes} دقيقة`;
  }
  if (isSameDay) return 'اليوم';
  if (isTomorrow) return 'غدًا';

  const days = Math.ceil(diffMs / 86400000);
  const dayLabel = days === 2 ? 'يومين' : days > 10 ? `${days} يوماً` : `${days} أيام`;
  return `متبقي ${dayLabel}`;
};

// يعيد النص ويُحدّثه تلقائياً كل دقيقة بلا إعادة تحميل الصفحة
export const useLiveCountdown = (matchDateStr, status) => {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 60000);
    return () => clearInterval(id);
  }, []);
  return formatMatchCountdown(matchDateStr, status);
};
